<script lang="ts">
	import { Toast } from "toaster"

	interface Props {
		fileName: string
		fileType?: string
		fileId: string | number
		onRename: (newName: string) => void
		triggerRename?: () => void
	}

	let { fileName, fileType, fileId, onRename, triggerRename = $bindable() }: Props = $props()

	let labelElem: HTMLSpanElement = $state()

	triggerRename = () => {
		if (!onRename) return
		labelElem.contentEditable = "true"

		setTimeout(() => {
			const range = document.createRange()
			range.selectNodeContents(labelElem)
			const selection = window.getSelection()
			selection.removeAllRanges()
			selection.addRange(range)
		})
	}

	function checkIfRename(e: FocusEvent & { currentTarget: HTMLSpanElement }) {
		const value = e.currentTarget.innerText
		if (value === "") {
			labelElem.innerText = fileName
			return Toast.error("Name cannot be empty!")
		}

		if (value !== fileName) {
			onRename(value)
		}

		labelElem.contentEditable = "false"
	}

	function onKeypress(
		e: KeyboardEvent & {
			currentTarget: HTMLSpanElement
		},
	) {
		e.stopPropagation()
		e.stopImmediatePropagation()

		if (e.key === "Escape") {
			e.currentTarget.innerText = fileName
			e.currentTarget.blur()
		}
		if (e.key === "Enter") {
			e.preventDefault()
			e.currentTarget.blur()
		}
	}

	function initializeRename(
		e: MouseEvent & {
			currentTarget: EventTarget & HTMLSpanElement
		},
	) {
		e.stopImmediatePropagation()
	}
</script>

<span
	tabindex="0"
	id="tile-label-{fileType}-{fileId}"
	role="textbox"
	class="tile-label"
	bind:this={labelElem}
	onclick={(e) => e.stopImmediatePropagation()}
	onkeydown={onKeypress}
	onblur={checkIfRename}
	ondblclick={initializeRename}
	title={fileName}
>
	{fileName}
</span>

<style>
	.tile-label {
		max-width: var(--tile-width);

		display: flex;
		flex-direction: row;
		align-items: center;
		white-space: nowrap;
		overflow: hidden;
		text-overflow: ellipsis;
		width: 100%;
		max-width: var(--tile-width);
	}
</style>
